import { FC } from 'react';
import { AiOutlineCheck } from '@react-icons/all-files/ai/AiOutlineCheck';
import classNames from 'classnames';

import { StyledComponent } from 'types';
import { formatPrice } from 'utils/text-helpers';

export const PriceLabelTestIds = {
  container: 'price-label-container'
};

export type PriceLabelProps = {
  price?: number;
} & StyledComponent;

export const PriceLabel: FC<PriceLabelProps> = ({ price, className, style }) => {
  if (!price) {
    return null;
  }

  return (
    <div
      data-testid={PriceLabelTestIds.container}
      className={classNames('p-2 px-3 rounded-3', className)}
      style={{ background: 'rgba(10, 142, 109, 0.12)', ...style }}
    >
      <AiOutlineCheck className='mr-1 text-success' size={16} />
      <span className='text-success fs-16px line-height-32px letter-spacing-1'>{formatPrice(price)}</span>
    </div>
  );
};
